import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faLaptopCode, faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="03/2026 ~ now"
            iconStyle={{ background: '#ff5f5fff', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faLaptopCode} />}
          >
            <h3 className="vertical-timeline-element-title">Front Senior System Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">FPT Software Japan</h4>
            <p>
              Code review, AI agent application guidance, and technical customer communication
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="06/2025 ~ 02/2026"
            iconStyle={{ background: '#7328e2ff', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faLaptopCode} />}
          >
            <h3 className="vertical-timeline-element-title">Indie Hacker / Solo Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Chiba Prefecture (Japan 🇯🇵)</h4>
            <p>
              Full Stack Web Development, GenAI/LLM Powered App Development, SaaS Building
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="03/2023 ~ 05/2025"
            iconStyle={{ background: '#7328e2ff', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Full Stack SWE / Project Leader</h3>
            <h4 className="vertical-timeline-element-subtitle">Toshiba Software Development Vietnam (Vietnam 🇻🇳)</h4>
            <p>
              Full Stack Web Development, Project Management
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="03/2020 ~ 02/2023"
            iconStyle={{ background: '#7328e2ff', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Full Stack SWE / Bridge Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Toshiba System Technology Corporation (Japan 🇯🇵)</h4>
            <p>
            Full Stack Web Development, DevOps, Technical Communication, Offshore Coordination

            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="08/2015 ~ 02/2020"
            iconStyle={{ background: '#7328e2ff', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Software Engineer / Team Leader</h3>
            <h4 className="vertical-timeline-element-subtitle">Toshiba Software Development Vietnam (Vietnam 🇻🇳)</h4>
            <p>
              Full Stack Development, Technical Leadership
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="05/2014 ~ 07/2015"
            iconStyle={{ background: '#319EFE', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faUserGraduate} />}
          >
            <h3 className="vertical-timeline-element-title">Security Researcher Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">BKAV Corporation (Vietnam 🇻🇳)</h4>
            <p>
              Web Development, Cyber Security Research
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;